import { render, staticRenderFns } from "./form_management.vue?vue&type=template&id=a5cc93c8&scoped=true&"
import script from "./form_management.vue?vue&type=script&lang=js&"
export * from "./form_management.vue?vue&type=script&lang=js&"
import style0 from "./form_management.vue?vue&type=style&index=0&id=a5cc93c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cc93c8",
  null
  
)

export default component.exports